export var mutations = {
    SET_COMPONENTS (state, components) {
        state.components = components
    },
    SET_INCIDENTS (state, incidents) {
        state.incidents = incidents
    },
    SET_COMPONENT (state, component) {
        state.component = component
    },
    SET_LATEST_INCIDENTS (state, incidents) {
        state.latestIncidents = incidents
    },
    SET_IS_LOADING (state, isLoading) {
        state.isLoading = isLoading
    },
    SET_INCIDENT (state, incident) {
        state.incident = incident
    },
    SET_STATUS (state, status) {
        state.status = status
    },
    SET_REPORT_DATA (state, data) {
        state.reportData = data
    },
    SET_BASE_API_URL (state, baseApiUrl) {
        state.baseApiUrl = baseApiUrl
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js